<template>
  <transition
    name="fade-content"
    appear
    mode="out-in"
  >
    <div class="landing-page-inner landing-page-contacts">
      <div class="landing-page__container landing-page__container_expand">
        <div class="landing-page-contacts-row">
          <div class="landing-page-contacts-row__info">
            <h2 class="landing-page__title">
              {{ $t('landingPage.contactsPage.title') }}
            </h2>
            <div class="landing-page-contacts-row__desc">
              {{ $t('landingPage.contactsPage.description') }}
            </div>
            <div class="information">
              <div
                v-for="item in informations"
                :key="item.id"
                class="information__row"
              >
                <div class="information__row-icon">
                  <i :class="item.icon"></i>
                </div>
                <div class="information__row-text">
                  <div class="information__row-label">
                    {{ $t(item.label) }}
                  </div>
                  <div class="information__row-desc">
                    <template v-if="item.link">
                      <a :href="item.link">{{ $t(item.text) }}</a>
                    </template>
                    <template v-else>
                      {{ $t(item.text) }}
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="map"
            class="landing-page-contacts-row__map"
          >
            <yandex-map
              :coords="coords"
              zoom="15"
              :settings="settings"
            >
              <ymap-marker
                markerId="map-contacts"
                :coords="coords"
                :icon="markerIcon"
                markerType="placemark"
              />
            </yandex-map>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import informations from '@/constants/landing/contactInfo';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';

export default {
  name: 'Contacts',
  components: {
    yandexMap,
    ymapMarker,
  },
  data: () => ({
    informations,
    coords: [25.080163, 55.153327],
    markerIcon: {
      layout: 'default#imageWithContent',
      // eslint-disable-next-line global-require
      imageHref: require('@/assets/images/marker.png'),
      imageSize: [30, 38],
      imageOffset: [0, 0],
      content: '',
      contentOffset: [35, 15],
    },
  }),
  computed: {
    settings() {
      return { lang: this.language };
    },
    language: {
      get() {
        return this.$i18n.locale;
      },
      set(data) {
        this.$i18n.locale = data;
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "../sass/variables";
@import "../sass/mixins";

.landing-page-contacts {
  font-family: $font-landing-global;
  display: flex;
  height: 100%;
  padding: 80px 0 80px 0;
  align-items: center;

  @include mobile {
    .landing-page__container {
      padding: 0;
    }
  }

  @include tablet-landscape {

    .landing-page-contacts-row {
      align-items: center;
    }
  }

  &-row {
    display: flex;
    color: $color-black;
    justify-content: space-between;

    @include only-tablet-landscape {
      justify-content: flex-start;
    }

    @include tablet-portrait {
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 60px;
    }

    @include mobile {
      margin-top: 74px;
    }

    &__desc {
      margin-top: 19px;
      font-size: $font-size-landing-md;
      margin-bottom: 48px;
      max-width: 560px;
      line-height: 1.4;

      @include mobile {
        margin-bottom: 42px;
        font-size: $font-size-landing-sm;
        margin-top: 12px;
      }
    }

    &__info {
      width: 40%;
      margin-right: 50px;

      @include only-tablet-landscape {
        margin-right: 10px;
        width: 50%;
      }

      @include tablet-portrait {
        margin-right: 0;
        width: 100%;
      }

      @include mobile {
        padding: 0 20px;
      }
    }

    &__map {
      width: 60%;
      margin-left: 100px;

      @include only-tablet-landscape {
        margin-left: 10px;
        width: 50%;
      }

      @include tablet-portrait {
        margin-left: 0;
        width: 100%;
        margin-top: 50px;
      }

      @include mobile {
        margin-top: 40px;
      }

      .ymap-container {
        height: 686px;

        @include tablet-landscape {
          height: 450px;
        }

        @include mobile {
          height: 256px;
        }
      }
    }
  }

  .information {

    &__item {
      display: flex;
    }

    &__row {
      display: flex;
      margin-bottom: 42px;

      @include tablet-landscape {
        margin-bottom: 20px;
      }

      @include mobile {
        margin-bottom: 30px;
      }

      &-label {
        margin-top: 2px;

        @include tablet-landscape {
          margin-top: 0;
        }

        @include mobile {
          font-size: $font-size-landing-sm;
        }
      }

      &-desc {
        margin-top: 8px;

        @include tablet-landscape {
          margin-top: 0;
        }

        @include mobile {
          font-size: $font-size-landing-sm;
          margin-top: 4px;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }

      &-icon {
        width: 48px;
        min-width: 48px;
        max-width: 48px;
        height: 48px;
        min-height: 48px;
        max-height: 48px;
        background: $color-dodger-blue;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: $font-size-icon-ml;
          color: $color-white;
          position: relative;
          top: 1px;

          &.ub-icon-email {
            font-size: $font-size-icon-xd;
            right: 1px;
          }

          &.ub-icon-clock {
            top: 2px;
          }
        }
      }

      &-text {
        font-size: $font-size-landing-medium;
        line-height: 1.5;
        margin-left: 16px;
      }

      &-desc {
        font-family: $font-landing-medium;

        a {
          text-decoration: none;
          color: $color-black;
          transition: color .15s ease-in;

          &:hover {
            color: $color-dodger-blue;
          }
        }
      }
    }
  }
}
#map {
  filter: grayscale(.2);
}

@include tablet-portrait {
  .landing-page-contacts {
    padding-top: 0;
  }
}
</style>
